// extracted by mini-css-extract-plugin
export default {"wrapper":"CardCarousel_wrapper__A5bmo","template":"CardCarousel_template__jSn3G","viewport":"CardCarousel_viewport__2X3j6","track":"CardCarousel_track__hxius"};